import React, { useEffect, useState } from 'react';

import MobileTeamDetails from 'components/organisms/Profile/TeamDetails/MobileTeamDetails';
import TabletTeamDetails from 'components/organisms/Profile/TeamDetails/TabletTeamDetails';
import DesktopTeamDetails from 'components/organisms/Profile/TeamDetails/DesktopTeamDetails';
import { useSnackbar } from 'contexts/snackbar';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import groupService from 'services/group';
import useFormValidation from 'services/hooks/useFormValidation';

const TeamDetails = ({ setSelected }) => {
    const { message } = useSnackbar();
    const { currentGroup, updateCurrentGroup } = useUser2();
    const { device } = useViewport();

    const [form, setForm] = useState({ teamName: currentGroup.name });
    const [isDirty, setIsDirty] = useState(false);
    const [hasClickedSubmit, setHasClickedSubmit] = useState(false);

    const getErrorMessage = (key, value) => {
        if (['teamName'].includes(key)) value = value?.trim();
        switch (key) {
            case 'teamName':
                return value ? '' : 'Please enter a team name';
            default:
                return '';
        }
    };

    const { errors, validate, validateAll } = useFormValidation(form, getErrorMessage);

    const handleChange = (e) => {
        const { name: key, value } = e.target;
        setForm((current) => ({ ...current, [key]: value }));
        setIsDirty(true);
        if (hasClickedSubmit || errors[key]) {
            validate(key, value);
        }
    };

    const handleSubmit = async () => {
        if (!hasClickedSubmit) setHasClickedSubmit(true);
        if (!validateAll()) return;

        updateCurrentGroup({ name: form.teamName });
        await groupService.updateGroup(currentGroup.id, { name: form.teamName });
        message.success('Team name has been updated.');

        setIsDirty(false);
    };

    useEffect(() => {
        if (!isDirty) validateAll();
    }, [isDirty]);

    const props = {
        form,
        errors,
        onChange: handleChange,
        onSubmit: handleSubmit,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <MobileTeamDetails {...props} setSelected={setSelected} />,
            tablet: <TabletTeamDetails {...props} />,
            desktop: <DesktopTeamDetails {...props} />,
        }[device];
    };

    return <>{renderResponsiveLayout(device)}</>;
};

export default TeamDetails;
